module.exports = __webpack_public_path__ + "static/media/Vamp1.307d99e1.png";